<template>
  <ListView
    modelName="SalesOrderItem"
    perm="sales.menu_sales_order_item"
    svg="icon_side_orders_list" 
    color="steelblue"
    :items.sync="items"
    :params.sync="params"
    title="menu_sales_order_item"
    :key="$route.fullPath"
    :sortOptions="sortOptions"
    ref="mainList"
    :tabs="['基本情報']"
    gridKey="SalesOrderItem"
    :gridCaptions="listCaptions"
    :gridWidths="listWidths"
    :gridVisibles="listVisbles"
    :onCreate="onCreate"
    :importQuery="importQuery"
    :exportQuery="exportQuery"
    @selected="onSelectedMain"
    borderColor="#E35F71"
    backColor="#FFF1F3"        
    tourId="291628"
    :comparer="(a,b)=>a.id == b.id"    
    :popup="popup"    
    :checkStateObject="(a)=>a.order"
  >
    <!-- 明細項目の配置 -->
    <GridItem :slot="listSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="salesOrderItemStatus"/></GridItem>
    <GridItem :slot="listSlots[1]" slot-scope="{ item, index, listView}" :func="true" @click="listView.onOpenDialogByIndex(index)">{{ item.orderItemNo }}</GridItem>    
    <GridItem :slot="listSlots[2]" slot-scope="{ item }">{{ item.order.orderDate | date }}</GridItem>
    <GridItem :slot="listSlots[3]" slot-scope="{ item }">{{ item.order.counterpart.name }}</GridItem>
    <GridItem :slot="listSlots[4]" slot-scope="{ item }">{{ item.commodity.name }}</GridItem>
    <GridItem :slot="listSlots[5]" slot-scope="{ item }">{{ item.sku == null ? "" : item.sku.name }}</GridItem>
    <GridItem :slot="listSlots[6]" slot-scope="{ item }">{{ item.uom == null ? item.commodity.uom : item.uom.name }}</GridItem>
    <GridItem :slot="listSlots[7]" slot-scope="{ item }" :right="true">{{ item.quantity | numeric(item.commodity.quantityScale) }}</GridItem>
    <GridItem :slot="listSlots[8]" slot-scope="{ item }">{{ item.answerDeliveryDate | date }}</GridItem>
    <GridItem :slot="listSlots[9]" slot-scope="{ item }">{{ item.scheduledDeliveryDate | date }}</GridItem>
    <GridItem :slot="listSlots[10]" slot-scope="{ item }">{{ item.order.currencyCode | currency }}</GridItem>    
    <GridItem :slot="listSlots[11]" slot-scope="{ item }" :right="true">{{ item.unitPrice | numeric }}</GridItem>
    <GridItem :slot="listSlots[12]" slot-scope="{ item }">{{ item.taxCode | taxCode }}</GridItem>
    <GridItem :slot="listSlots[13]" slot-scope="{ item }" :right="true">{{ item.commodity.sellingPrice | numeric }}</GridItem>
    <GridItem :slot="listSlots[14]" slot-scope="{ item }" :right="true">{{ item.purchasePrice | numeric }}</GridItem>
    <GridItem :slot="listSlots[15]" slot-scope="{ item }" :right="true">{{ item.calcGrossProfit }}</GridItem>
    <GridItem :slot="listSlots[16]" slot-scope="{ item }">{{ item.supplier?item.supplier.name:'' }}</GridItem>
    <GridItem :slot="listSlots[17]" slot-scope="{ item }">{{ item.order.projectItem?item.order.projectItem.name:''}}</GridItem>    
    <GridItem :slot="listSlots[18]" slot-scope="{ item }">{{ item.order.segmentId | segment}}</GridItem>
    <GridItem :slot="listSlots[19]" slot-scope="{ item }">{{ item.order.pic | userGroup }}</GridItem>
    <GridItem :slot="listSlots[20]" slot-scope="{ item }">{{ item.orderNo }}</GridItem>
    <!-- <GridItem :slot="listSlots[1]" slot-scope="{ item }">{{ item.id }}</GridItem> -->
    <!-- <GridItem :slot="listSlots[3]" slot-scope="{ item }">{{ item.seqNo }}</GridItem> -->
    <!-- <GridItem :slot="listSlots[20]" slot-scope="{ item }">{{ item.description }}</GridItem> -->
    <GridItem :slot="listSlots[21]" slot-scope="{ item }">{{ item.commodityName }}</GridItem>
    <GridItem :slot="listSlots[22]" slot-scope="{ item }">{{ item.isNCV | isTarget }}</GridItem>
    <GridItem :slot="listSlots[23]" slot-scope="{ item }">{{ item.commodity.isNoStock | isNoStock }}</GridItem>
    <GridItem :slot="listSlots[24]" slot-scope="{ item }" :right="true">{{ item.dealAmountFC | amountFC(item.order.currencyCode) }}</GridItem>
    <GridItem :slot="listSlots[25]" slot-scope="{ item }" :right="true">{{ item.allocatedQuantity | numeric(item.commodity.quantityScale) }}</GridItem>
    <GridItem :slot="listSlots[26]" slot-scope="{ item }" :right="true">{{ item.closedQuantity | numeric(item.commodity.quantityScale) }}</GridItem>
    <GridItem :slot="listSlots[27]" slot-scope="{ item }" :right="true">{{ item.backOrderQuantity | numeric(item.commodity.quantityScale) }}</GridItem>
    <GridItem :slot="listSlots[28]" slot-scope="{ item }" :right="true">{{ item.backSalesOrderQuantity | numeric(item.commodity.quantityScale) }}</GridItem>
    <GridItem :slot="listSlots[29]" slot-scope="{ item }" :right="true">{{ item.purchasePendingQuantity | numeric(item.commodity.quantityScale) }}</GridItem>
    <GridItem :slot="listSlots[30]" slot-scope="{ item }" :right="true">{{ item.backPostingQuantity | numeric(item.commodity.quantityScale) }}</GridItem>    
    <GridItem :slot="listSlots[31]" slot-scope="{ item }">{{ item.order.refNo }}</GridItem>
    <GridItem :slot="listSlots[32]" slot-scope="{ item }">{{ item.order.customerOrderNo }}</GridItem>
    <!-- <GridItem :slot="listSlots[32]" slot-scope="{ item, index }"><Workflow :item="item" :index="index" @updated="onWorkflow"/></GridItem> -->
    <GridItem :slot="listSlots[33]" slot-scope="{ item }">{{ item.initialSavedOn | timestamp }}</GridItem>
    <GridItem :slot="listSlots[34]" slot-scope="{ item }">{{ item.initialSavedBy | user }}</GridItem>
    <GridItem :slot="listSlots[35]" slot-scope="{ item }">{{ item.lastUpdatedOn | timestamp }}</GridItem>
    <GridItem :slot="listSlots[36]" slot-scope="{ item }">{{ item.lastUpdatedBy | user  }}</GridItem>

    <!-- 予備項目 -->
    <GridItem :slot="listSlots[37]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText1 == usedTypes.CommodityMemo ? item.commodity.reserveText1 : item.reserveText1)}}</GridItem>
    <GridItem :slot="listSlots[38]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText2 == usedTypes.CommodityMemo ? item.commodity.reserveText2 : item.reserveText2)}}</GridItem>
    <GridItem :slot="listSlots[39]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText3 == usedTypes.CommodityMemo ? item.commodity.reserveText3 : item.reserveText3)}}</GridItem>
    <GridItem :slot="listSlots[40]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText4 == usedTypes.CommodityMemo ? item.commodity.reserveText4 : item.reserveText4)}}</GridItem>
    <GridItem :slot="listSlots[41]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText5 == usedTypes.CommodityMemo ? item.commodity.reserveText5 : item.reserveText5)}}</GridItem>
    <GridItem :slot="listSlots[42]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText6 == usedTypes.CommodityMemo ? item.commodity.reserveText6 : item.reserveText6)}}</GridItem>
    <GridItem :slot="listSlots[43]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveMemo1 == usedTypes.CommodityMemo ? item.commodity.reserveMemo1 : item.reserveMemo1)}}</GridItem>
    <GridItem :slot="listSlots[44]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveMemo2 == usedTypes.CommodityMemo ? item.commodity.reserveMemo2 : item.reserveMemo2)}}</GridItem>
    <GridItem :slot="listSlots[45]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveMemo3 == usedTypes.CommodityMemo ? item.commodity.reserveMemo3 : item.reserveMemo3)}}</GridItem>
    <GridItem :slot="listSlots[46]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveDate1 == usedTypes.CommodityMemo ? item.commodity.reserveDate1 : item.reserveDate1)| date}}</GridItem>
    <GridItem :slot="listSlots[47]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveDate2 == usedTypes.CommodityMemo ? item.commodity.reserveDate2 : item.reserveDate2)| date}}</GridItem>
    <GridItem :slot="listSlots[48]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveDate3 == usedTypes.CommodityMemo ? item.commodity.reserveDate3 : item.reserveDate3)| date}}</GridItem>
    <GridItem :slot="listSlots[49]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveList1 == usedTypes.CommodityMemo ? item.commodity.reserveList1 : item.reserveList1 ) | category_41}}</GridItem>
    <GridItem :slot="listSlots[50]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveList2 == usedTypes.CommodityMemo ? item.commodity.reserveList2 : item.reserveList2 ) | category_42}}</GridItem>
    <GridItem :slot="listSlots[51]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveList3 == usedTypes.CommodityMemo ? item.commodity.reserveList3 : item.reserveList3 ) | category_43}}</GridItem>

    <!-- リストメニューの配置 -->
    <template slot="menu" slot-scope="{ listView }">
      <ListViewMenuBar :listView="listView" :add="false" :copy="false" >
        <ListViewMenu title="出荷引当" @click="showBulkAllocateDialog" tooltip="複数の【受注明細】の出荷引当(在庫の確保)を行い、出荷明細を作成します。"/>
        <ListViewMenu title="出荷引当(個別)" @click="showAllocateDialog" tooltip="単一の【受注明細】の出荷引当(在庫の確保)を行い、出荷明細を作成します。"/>
        <ListViewMenu title="発注処理" @click="showCreatePurchaseOrderDialog" tooltip="【受注明細】に対応する発注伝票・発注明細伝票を作成します。"/>
        <ListViewMenu title="納期更新" @click="showUpdateDeliveryDateDialog" tooltip="【回答納期】と【出荷予定日】を一括で更新する事ができます。"/>
        <ListViewMenu title="契約日付更新" @click="showUpdateSubscriptionEndDate" tooltip="【契約完了日】を一括で更新する事ができます。"/>
      </ListViewMenuBar>
    </template>
    <!-- 検索パネルーの配置 -->
    <template slot="search" slot-scope="{ params, handler, listView }">
      <Search :listView="listView" :tabs="searchTabs">
        <FilterBox title="受注番号" :value.sync="params.orderNo" @click="handler" />
        <FilterBox title="受注明細番号" :value.sync="params.orderItemNo" @click="handler" />
        <FilterBox title="受注管理番号" :value.sync="params.refNo" @click="handler" />
        <FilterBox title="顧客注文番号" :value.sync="params.customerOrderNo" @click="handler" />
        <FilterBox title="商品名称" :value.sync="params.commodityName" @click="handler" />
        <FilterBox title="備考" :value.sync="params.description" @click="handler" />
        <AtcSegment title="部門" :value.sync="params.segment" @changed="handler" />
        <AtcCounterpart title="得意先" :value.sync="params.counterpart" :needsCustomer="true" @changed="handler" />
        <AutoComplete title="担当者" :value.sync="params.pic" list="user" @changed="handler" />
        <AutoComplete title="取引通貨"  :value.sync="params.currencyCode" list="currency" @changed="handler" v-if="hasLicenseCurrency" />         
        <AtcCommodity title="商品" :value.sync="params.commodity" @changed="handler" />
        <AtcSKU title="SKU" :value.sync="params.sku" :commodity="params.commodity" @update:value="handler" />       
        <Calendar title="契約完了日" :value.sync="params.subscriptionEndDate" :deletable="true" @changed="handler" />
        <Calendar title="受注日(From)" :value.sync="params.orderDateFrom" :deletable="true" @changed="handler" />
        <Calendar title="受注日(To)" :value.sync="params.orderDateTo" :deletable="true" @changed="handler" />
        <Calendar title="回答納期(From)" :value.sync="params.answerDeliveryDateFrom" :deletable="true" @changed="handler" />
        <Calendar title="回答納期(To)" :value.sync="params.answerDeliveryDateTo" :deletable="true" @changed="handler" />
        <Calendar title="出荷予定日(From)" :value.sync="params.scheduledDeliveryDateFrom" :deletable="true" @changed="handler" />
        <Calendar title="出荷予定日(To)" :value.sync="params.scheduledDeliveryDateTo" :deletable="true" @changed="handler" />
        <Calendar title="初回保存日(From)" :value.sync="params.initialSavedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="初回保存日(To)" :value.sync="params.initialSavedOnTo" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(From)" :value.sync="params.lastUpdatedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(To)" :value.sync="params.lastUpdatedOnTo" :deletable="true" @changed="handler" />
        <!-- <ComboBox title="所有者" :value.sync="params.holder" list="user" @changed="handler" /> -->
        <AutoComplete title="所有者" :value.sync="params.holder" list="user" @changed="handler" />         
        <ComboBox title="状態" :value.sync="params.state" :list="hasLicenseCurrency ? 'salesOrderItemStatus' : 'salesOrderItemStatusNoLicenseCurrency'" @changed="handler" />

        <FilterBox slot="tab1" title="reserve_text1" :value.sync="params.reserveText1" @click="handler"   v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText1)" />
        <FilterBox slot="tab1" title="reserve_text2" :value.sync="params.reserveText2" @click="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText2)"/>
        <FilterBox slot="tab1" title="reserve_text3" :value.sync="params.reserveText3" @click="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText3)"/>
        <FilterBox slot="tab1" title="reserve_text4" :value.sync="params.reserveText4" @click="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText4)"/>
        <FilterBox slot="tab1" title="reserve_text5" :value.sync="params.reserveText5" @click="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText5)"/>
        <FilterBox slot="tab1" title="reserve_text6" :value.sync="params.reserveText6" @click="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText6)"/>
        <FilterBox slot="tab1" title="reserve_memo1" :value.sync="params.reserveMemo1" @click="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveMemo1)"/>
        <FilterBox slot="tab1" title="reserve_memo2" :value.sync="params.reserveMemo2" @click="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveMemo2)"/>
        <FilterBox slot="tab1" title="reserve_memo3" :value.sync="params.reserveMemo3" @click="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveMemo3)"/>
        <Calendar slot="tab1" title="reserve_date1|(From)" :value.sync="params.reserveDate1From" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate1)"/>
        <Calendar slot="tab1" title="reserve_date1|(To)" :value.sync="params.reserveDate1To" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate1)"/>
        <Calendar slot="tab1" title="reserve_date2|(From)" :value.sync="params.reserveDate2From" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate2)"/>
        <Calendar slot="tab1" title="reserve_date2|(To)" :value.sync="params.reserveDate2To" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate2)"/>
        <Calendar slot="tab1" title="reserve_date3|(From)" :value.sync="params.reserveDate3From" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate3)"/>
        <Calendar slot="tab1" title="reserve_date3|(To)" :value.sync="params.reserveDate3To" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate3)"/>
        <ComboBox slot="tab1" title="reserve_list1" :value.sync="params.reserveList1" list="category_41" @changed="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveList1)"/>
        <ComboBox slot="tab1" title="reserve_list2" :value.sync="params.reserveList2" list="category_42" @changed="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveList2)"/>
        <ComboBox slot="tab1" title="reserve_list3" :value.sync="params.reserveList3" list="category_43" @changed="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveList3)"/>        
      </Search>
    </template>
    <!-- フルサイズエディタの配置(ListView:fullSizeEditor="true"を指定) -->
    <template slot="sideEditor" slot-scope="{ listView }">
      <Editor :item="listView.selected" :owner="listView" :tabs="['基本情報','出荷明細','発注明細','その他情報','納入先詳細','予備項目','更新履歴']" :tabVisibles="tabVisibles" :tabTooltips="[null,'選択した受注明細に紐づいている出荷明細を表示します。','選択した受注明細に紐づいている発注明細を表示します。',null,'【納入先】の情報が表示されます。【受注明細一覧】の【編集】ボタンからは変更できません。','商品単位で任意にテキスト入力・区分の設定・日付設定を行えます｡項目名は【テナント設定】＞【商品予備項目】から変更が可能です。',null]">
        <!-- エディタ編集・機能ボタン -->
        <template slot="menu" slot-scope="{item, editor}">
          <SplitButton class="button" @click="showDirectAccessDialg(item)" caption="関連伝票"  icon="account_tree" tooltip="関連する伝票へのリンクを表示します。">            
          <!-- <Button class="button" @click="showSalesOrder" caption="伝票表示" :disabled="editor.isEdit" icon="arrow_upward"/> -->
          <Button class="button" @click="showPurchaseOrderItems" caption="発注明細表示" :disabled="editor.isEdit || disabledShowPurchaseOrderItemButton" icon="arrow_forward" tooltip="選択した【受注明細】に紐づく【発注明細】を表示します。"/>
          <Button class="button" @click="showSalesDeliveryItems" caption="出荷明細表示" :disabled="editor.isEdit || disabledShowSalesDeliveryItemButton" icon="arrow_forward" tooltip="選択した【受注明細】に紐づく【出荷明細】を表示します。"/>
          </SplitButton>
        </template>
        <!-- 基本情報タブ -->
        <template slot="tab0" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 基本情報タブ 左側 -->
            <template slot="left">
              <!-- <TextBox title="明細番号" :value="item.orderItemNo" :editor="editor" :enabled="false" /> -->
              <RowSequence title="明細番号" :value="item.seqNo" :displayValue="item.orderItemNo" :perm="$refs.mainList.perm+'.edit'" :item="item" :editor="editor" :enabled="isEditable(item.state)" tooltip="受注番号に紐づく明細番号が初回保存時に自動で付与されます。" buttonTooltip="1件の伝票に複数の明細が登録されている場合､明細の順番を変更する事ができます。明細の数が１つしかない場合は変更できません。" />
              <!-- <TextBox title="明細ID" :value="item.id" :editor="editor" :enabled="false" /> -->
              <TextBox title="受注日" :editor="editor" :value="$api.formatter.formatDate(item.order != null ? item.order.orderDate : null)" :enabled="false" tooltip="【受注一覧】で登録した受注日が表示されます。【受注明細一覧】からは変更できません。"/>
              <!-- <TextBox title="得意先" :value="(item.order != null ? item.order.counterpartId : null) | counterpart" :editor="editor" :enabled="false" /> -->
              <AtcCounterpart title="得意先" :value="item.order != null ? item.order.counterpart : null" :editor="editor" :needsCustomer="true" :enabled="false" tooltip="【受注一覧】で登録した得意先が表示されます。【受注明細一覧】からは変更できません。"/>              
              <AtcCommodity title="商品" :value.sync="item.commodity" :editor="editor" :required="true" :enabled="isEditable(item.state)" @update:value="onChangeCommodity(item)" tooltip="登録する商品を選択します。【商品一覧】のデータを選択できます。"/>
              <AtcSKU title="SKU" :value.sync="item.sku" :editor="editor" :commodity="item.commodity" :enabled="isEditable(item.state)" tooltip="【商品】に対応したSKUを選択できます。【SKU一覧】より商品にSKUを設定している場合に、選択が可能です。"/>              
              <div class="cx_controls">
                <AtcConversion title="単位" :value.sync="item.uom2" :editor="editor" :required="true" :enabled="isEditable(item.state)" :commodity="item.commodity" tooltip="【商品】に対応した単位が選択可能です。【商品一覧】に登録されている【計上単位】､【荷姿一覧】に登録した単位が表示されます。"/>              
                <BtnStockSchedule v-if="$api.useStockFunction" :commodity="item.commodity" :sku="item.sku" :stockDate="item.scheduledDeliveryDate" :segment="item.order.segment"/>
              </div>                  
              <NumericBox title="受注数量" :value.sync="item.quantity" :editor="editor" :required="true" :enabled="!isStateLost(item.state) && (item.order.isSubscription == false)" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" :min="getMinQuantity(item)" max="99999999.999" :nullValue="0" />
              <TextBox title="取引通貨" :value="item.order.currencyCode| currency"  :enabled="false" v-if="hasLicenseCurrency" />
              <div class="cx_controls">
                <NumericBox title="単価" :value.sync="item.unitPrice" :editor="editor" :required="false" :enabled="!isStateLost(item.state)" :decimals="item.commodity == null ? 0 : item.commodity.stockPriceScale" min="-999999999.999999" max="999999999.999999"/>
                <Button class="button cx_itembutton" style="margin-left:10px"  @click="getPriceAndTaxCode(item)" caption="単価取得" :disabled="!editor.isEdit" tooltip="商品の単価を取得します。単価の取得基準は【商品一覧】の【販売単価区分】で登録をします。"/>
              </div>
              <AtcTaxCode title="税区分" :value.sync="item.taxCode" :editor="editor" list="taxCode" :required="true" :enabled="isEditable(item.state)" tooltip="登録する税区分を選択します。【税区分一覧】のデータを選択できます。"/>              
            </template>
            <!-- 基本情報タブ 右側 -->
            <template slot="right">
              <TextBox title="受注番号" :value="item.orderNo" :editor="editor" :enabled="false" linkFormat="/sales/SalesOrder?orderNo={0}" tooltip="受注明細番号に対応する受注番号が表示されています。クリックすることで受注一覧に移動します。"/>
              <Calendar title="希望納期" :value.sync="item.itemRequestDate" :editor="editor" :deletable="true" :enabled="isEditable(item.state)" tooltip="お客様が希望する納期を入力できます。初期値は受注伝票の【希望納期】が設定されています。"/>
              <Calendar title="回答納期" :value.sync="item.answerDeliveryDate" :editor="editor" :deletable="true" :enabled="isEditable(item.state)" tooltip="お客様に商品が到着する予定日を入力できます。お客様の希望する納期である【希望納期】とは異なります。"/>              
              <Calendar title="出荷予定日" :value.sync="item.scheduledDeliveryDate" :editor="editor" :deletable="true" :enabled="isEditable(item.state)" tooltip="受注した商品の出荷を予定している日付を入力します。"/>
              <AtcCounterpart title="発注先" :value.sync="item.supplier" :editor="editor" :needsSupplier="true" :enabled="isEditable(item.state)" tooltip="商品を発注する仕入先を選択します。【取引先一覧】の【取引先種別】が【仕入先】になっているデータが選択できます。"/>
              <AtcSegment title="部門" :value.sync="item.order.segment" :enabled="false" tooltip="受注一覧で登録した部門が表示されています。受注明細一覧からの変更は出来ません。"/>
              <AutoComplete title="担当者" :value.sync="item.order.pic"  list="user"  :enabled="false" tooltip="受注一覧で登録した担当者が表示されています。受注明細一覧からの変更は出来ません。"/>              
              <TextBox title="最終更新日" :value="$api.perms.getLastUpdateLabel(item)" :enabled="false" tooltip="受注データを最後に更新した日時が表示されています。"/>              
              <TextBox title="状態" :value="$api.perms.getStateLabel(item,'salesOrderItemStatus')" :enabled="false" tooltip="受注明細データの現在の状態が表示されており､業務処理や受注一覧で確定を行う事で変化します。" />                       
            </template>
          </EditPanel>
        </template>
        <!-- 出荷明細タブ -->
        <template slot="tab1" slot-scope="{ item}">
          <GrdVoucherItem :voucherNo="item.orderItemNo" :voucherType="voucherTypes.SalesOrderItem" :voucherItemType="voucherTypes.SalesDeliveryItem" ref="salesDeliveryItems"/>
        </template>         
        <!-- 発注明細タブ -->
        <template slot="tab2" slot-scope="{ item}" >
          <GrdVoucherItem :voucherNo="item.orderItemNo" :voucherType="voucherTypes.SalesOrderItem" :voucherItemType="voucherTypes.PurchaseOrderItem" ref="purchaseOrderItems"/>
        </template>                      
        <!-- その他情報タブ -->
        <template slot="tab3" slot-scope="{ item,editor}">
          <EditPanel>
            <!-- その他情報タブ 左側 -->
            <template slot="left">
              <TextBox title="商品名称" :value.sync="item.commodityName" :editor="editor" :required="true" :enabled="isEditable(item.state)" length="100" tooltip="初期値は【商品一覧】の【名称】の値になっていますが､任意で変更する事が可能です。"/>
              <NumericBox title="仕入単価" :value.sync="item.purchasePrice" :editor="editor" :required="false" :enabled="isComplete(item.state)==false && isStateLost(item.state) == false" :decimals="item.commodity == null ? 0 : item.commodity.stockPriceScale" min="-999999999.999999" max="999999999.999999" tooltip="受注時点での粗利を算出するための仕入単価です。任意で変更する事が可能です。発注の単価には引き継がれませんのでご注意ください。"/>
              <CheckBox title="NCV" :value.sync="item.isNCV" :editor="editor" list="isTarget" :enabled="isEditable(item.state)" v-if="hasLicenseCurrency" />                      
              <TextBox title="棚卸対象外" :value="(item.commodity != null ? item.commodity.isNoStock : false) | isNoStock" :editor="editor" :enabled="false" tooltip="【商品】に登録した商品の【棚卸商品区分】の値が表示されます。" />
              <TextBox title="取引金額" :value="$api.formatter.formatAmountFC(item.dealAmountFC,item.order.currencyCode)" :enabled="false"  :nullValue="0" tooltip="取引金額が表示されます。【受注数量×単価】の計算方法で出力されています。" />
              <NumericBox title="引当済み数量" :value.sync="item.allocatedQuantity" :editor="editor" :enabled="false"  :nullValue="0" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" tooltip="出荷引当がされている数量が表示されています。"/>
              <NumericBox title="クローズ数量" :value.sync="item.closedQuantity" :editor="editor" :enabled="item.quantity-item.allocatedQuantity-item.purchasePendingQuantity!=0 && !isStateLost(item.state) && !isEditable(item.state)"  :nullValue="0" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" :min="0" :max="item.quantity-item.allocatedQuantity-item.purchasePendingQuantity" tooltip="受注数量に対してクローズ（終了）とされた数量です。受注残がある場合、任意で変更することが可能です。" />                
              <NumericBox title="受注残数量" :value.sync="item.backOrderQuantity" :editor="editor" :enabled="false"  :nullValue="0" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" tooltip="受注数量から引当や出荷、クローズされた数量を引いた数値が表示されます。【受注数量－引当済数量－受注クローズ数量＝受注残数量】"/> 
              <NumericBox title="(引当待ち数量)" :value.sync="item.backSalesOrderQuantity" :editor="editor" :enabled="false"  :nullValue="0" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" tooltip="受注数量から引当や出荷、発注、クローズされた数量を引いた数値が表示されます。"/>     
              <NumericBox title="(入荷待ち数量)" :value.sync="item.purchasePendingQuantity" :editor="editor" :enabled="false"  :nullValue="0" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" tooltip="発注して入荷待ちの数量です。【発注数量－入荷数量(確定)－発注クローズ数量＝(入荷待ち数量)】" />                                        
            </template>
            <!-- その他情報タブ 右側 -->
            <template slot="right">
              <TextBox title="受注管理番号" :value.sync="item.order.refNo" :enabled="false" tooltip="受注一覧で登録した【受注管理番号】が表示されます。【受注明細一覧】の【編集】ボタンからは変更できません。" />
              <TextBox title="顧客注文番号" :value.sync="item.order.customerOrderNo" :enabled="false" tooltip="受注一覧で登録した【顧客注文番号】が表示されます。【受注明細一覧】の【編集】ボタンからは変更できません。"/>       
              <TextBox title="一式表記" :value.sync="item.groupingName"  :editor="editor" :enabled="isEditable(item.state)" length="25" tooltip="一式表記を指定すると、対外帳票で一式表記(集計行)が行えます。"/>                   
              <Calendar title="契約開始日" :value.sync="item.subscriptionStartDate" :editor="editor"  :enabled="isEditable(item.state)" v-if="item.order.isSubscription"/>               
              <Calendar title="契約完了日" :value.sync="item.subscriptionEndDate" :editor="editor"  :enabled="isEditable(item.state)" v-if="item.order.isSubscription"/>     
              <NumericBox title="月次数量" :value.sync="item.monthlyQuantity" :editor="editor" :required="true" :enabled="isEditable(item.state)" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" min="-99999999.999" max="99999999.999" :nullValue="0"  v-if="item.order.isSubscription"/>                        
              <Calendar title="次回清算日" :value.sync="item.nextSettlementDate" :editor="editor"  :enabled="false" tooltip="サブスクリプションの次回清算日が表示されます。"  v-if="item.order.isSubscription"/> 
              <TextBox title="備考" :value.sync="item.description" :editor="editor" :enabled="isEditable(item.state)" length="200" :rows="item.order.isSubscription ? 2 : 8" tooltip="任意で受注明細に関する情報を最大200文字まで入力できます。"/>
            </template>
          </EditPanel>

        </template>       
        <!-- 納入先詳細タブ -->
        <template slot="tab4" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 納入先詳細タブ 左側 -->
            <template slot="left">
              <TextBox title="納入先名称" :editor="editor" :value.sync="item.order.outputReceiverName" :enabled="false" length="50" />
              <TextBox title="担当部署名" :editor="editor" :value.sync="item.order.outputReceiverPICSection" :enabled="false" length="50" />
              <TextBox title="担当者" :editor="editor" :value.sync="item.order.outputReceiverPIC" :enabled="false" length="30" />
              <TextBox title="敬称" :editor="editor" :value.sync="item.order.outputReceiverPICHonorificTitle" :enabled="false" length="5" />
              <TextBox title="電話番号" :editor="editor" :value.sync="item.order.outputReceiverTelNo" :enabled="false" length="20" />
              <TextBox title="FAX番号" :editor="editor" :value.sync="item.order.outputReceiverFaxNo" :enabled="false" length="20" />
            </template>
            <!-- 納入先詳細タブ 右側 -->
            <template slot="right">
              <TextBox title="郵便番号" :editor="editor" :value.sync="item.order.outputReceiverPostalCode" :enabled="false" length="50" />
              <TextBox title="住所1" :editor="editor" :value.sync="item.order.outputReceiverAddress1" :enabled="false" length="50" />
              <TextBox title="住所2" :editor="editor" :value.sync="item.order.outputReceiverAddress2" :enabled="false" length="50" />
              <TextBox title="住所3" :editor="editor" :value.sync="item.order.outputReceiverAddress3" :enabled="false" length="50" />
            </template>
          </EditPanel>
        </template>    

        <!-- 予備項目タブ -->
        <template slot="tab5" slot-scope="{ item, editor }">
          <PnlReserveItems :item="item" :editor="editor" :enabled="isEditable(item.state)" :commodityAttribute="visibleTypes.Editable"  :orderMemo="visibleTypes.Editable" :commodity="item.commodity" />
          <!-- <EditPanel>
            <template slot="left">
              <TextBox title="テキスト1" :value.sync="item.reserveText1" :editor="editor" :enabled="isEditable(item.state)" length="50" />
              <TextBox title="テキスト2" :value.sync="item.reserveText2" :editor="editor" :enabled="isEditable(item.state)" length="50" />
              <TextBox title="テキスト3" :value.sync="item.reserveText3" :editor="editor" :enabled="isEditable(item.state)" length="50" />
              <TextBox title="テキスト4" :value.sync="item.reserveText4" :editor="editor" :enabled="isEditable(item.state)" length="50" />
              <TextBox title="テキスト5" :value.sync="item.reserveText5" :editor="editor" :enabled="isEditable(item.state)" length="50" />
              <TextBox title="テキスト6" :value.sync="item.reserveText6" :editor="editor" :enabled="isEditable(item.state)" length="50" />
              <AutoComplete title="選択1" :value.sync="item.reserveList1" :editor="editor" list="category_41" :enabled="isEditable(item.state)" />
              <AutoComplete title="選択2" :value.sync="item.reserveList2" :editor="editor" list="category_42" :enabled="isEditable(item.state)" />
              <AutoComplete title="選択3" :value.sync="item.reserveList3" :editor="editor" list="category_43" :enabled="isEditable(item.state)" />
            </template>
            <template slot="right">
              <Calendar title="日付1" :value.sync="item.reserveDate1" :editor="editor" :enabled="isEditable(item.state)" :deletable="true" />
              <Calendar title="日付2" :value.sync="item.reserveDate2" :editor="editor" :enabled="isEditable(item.state)" :deletable="true" />
              <Calendar title="日付3" :value.sync="item.reserveDate3" :editor="editor" :enabled="isEditable(item.state)" :deletable="true" />
              <TextBox title="メモ1" :value.sync="item.reserveMemo1" :editor="editor" :enabled="isEditable(item.state)" length="200" rows="2" />
              <TextBox title="メモ2" :value.sync="item.reserveMemo2" :editor="editor" :enabled="isEditable(item.state)" length="200" rows="2" />
              <TextBox title="メモ3" :value.sync="item.reserveMemo3" :editor="editor" :enabled="isEditable(item.state)" length="200" rows="2" />
            </template>
          </EditPanel> -->
        </template>
        <!-- 更新履歴タブ -->
        <template slot="tab6" slot-scope="{ item }">
          <AuditLog :auditName="item.auditName" :auditNo="item.auditNo" />
        </template>
      </Editor>
    </template>
    <template slot="modal" slot-scope="{ listView }">          
      <!-- 納期更新画面 -->
      <!-- <ListDialog ref="updateDeliveryDateDialog" title="納期更新" :captions="[]" :widths="[]" :showAdd="false" :showRemove="false" :exec="submitUpdateDeliveryDate" >
        <template slot="header">
          <Calendar title="回答納期" :value.sync="uddAnswerDeliveryDate" :deletable="true" tooltip="回答納期に変更があった場合変更された日付を入力します。"/>
          <Calendar title="出荷予定日" :value.sync="uddScheduledDeliveryDate" :deletable="true" tooltip="出荷予定日に変更があった場合変更された日付を入力します。"/>
        </template>
      </ListDialog> -->
      <!-- 契約日付更新画面 -->
      <ListDialog ref="updateSubscriptionEndDateDialog" title="契約日付更新" :captions="[]" :widths="[]" :showAdd="false" :showRemove="false" :exec="submitSubscriptionEndDate" >
        <template slot="header">
          <Calendar title="契約完了日" :value.sync="uddSubscriptionEndDate" :required="true" :deletable="true" tooltip="契約完了日を更新します。"/>
        </template>
      </ListDialog>
      <!-- 引当処理ダイアログ -->
      <ListDialog ref="allocateDialog" title="出荷引当(個別)" modelName="StockBalance"
        :captions="adCaptions"
        :widths="adWidths"
        :showAdd="false" :showRemove="false" :exec="submitAllocate"  :height="235" :width="1000">
        <!-- 引当処理ダイアログ ヘッダ項目 -->
        <template slot="header">
          <EditPanel>
            <template slot="left">
              <AtcSegment title="部門" :value="(adOrderItem.order ? adOrderItem.order.segment : null)" :enabled="false" tooltip="【受注明細一覧】で選択した【部門】が表示されます。"/>
              <!-- <TextBox title="商品" :value="adOrderItem.commodityName" :enabled="false" /> -->
              <AtcCommodity title="商品" :value="adOrderItem.commodity"  :enabled="false"  tooltip="【受注明細一覧】で選択した【商品】が表示されます。"/>
              <!-- <TextBox title="SKU" :value="adOrderItem.sku == null ? '' : adOrderItem.sku.name" :enabled="false" /> -->
              <AtcSKU title="SKU" :value.sync="adOrderItem.sku" :commodity="adOrderItem.commodity" :enabled="false"  tooltip="【受注明細一覧】で選択した【SKU】が表示されます。"/>              
              <TextBox title="棚卸対象外" :value="(adOrderItem.commodity != null ? adOrderItem.commodity.isNoStock : false) | isNoStock" :enabled="false" tooltip="【受注明細一覧】で選択した【棚卸対象外】の項目が表示されます。"/>
              <AtcConversion title="単位" :value="adOrderItem.uom2" :required="true" :commodity="adOrderItem.commodity" :nullValue="''" :enabled="false" tooltip="【受注明細一覧】で選択した【単位】が表示されます。"/>
              <NumericBox title="受注残数量" :value.sync="adBackSalesOrderQuantity" :enabled="false" :nullValue="0" :decimals="adOrderItem.commodity == null ? 0 : adOrderItem.commodity.quantityScale" tooltip="【受注明細一覧】で表示されている【受注残数量】が表示されます。"/>
            </template>
            <template slot="right">
              <!-- 商品識別情報のみ表示 -->
              <PnlReserveItems :item="adOrderItem" :tab="false" :enabled="false" :commodityAttribute="visibleTypes.Editable" :commodity="adOrderItem.commodity" />              
              </template>            
          </EditPanel>
        </template>
        <!-- 引当処理ダイアログ 一覧項目 -->
        <!-- <TextBox :slot="adSlots[0]" slot-scope="{ item }" :value="item.stockKey.segment ? item.stockKey.segment.name : ''" :enabled="false" /> -->
        <TextBox :slot="adSlots[0]" slot-scope="{ item }" :value="item.stockKey.warehouse ? item.stockKey.warehouse.name : ''" :enabled="false" />
        <TextBox :slot="adSlots[1]" slot-scope="{ item }" :value="item.stockKey.reserveText1" :enabled="false" />
        <TextBox :slot="adSlots[2]" slot-scope="{ item }" :value="item.stockKey.reserveText2" :enabled="false" />
        <TextBox :slot="adSlots[3]" slot-scope="{ item }" :value="item.stockKey.reserveText3" :enabled="false" />
        <TextBox :slot="adSlots[4]" slot-scope="{ item }" :value="item.stockKey.reserveText4" :enabled="false" />
        <TextBox :slot="adSlots[5]" slot-scope="{ item }" :value="item.stockKey.reserveText5" :enabled="false" />
        <TextBox :slot="adSlots[6]" slot-scope="{ item }" :value="item.stockKey.reserveText6" :enabled="false" />
        <TextBox :slot="adSlots[7]" slot-scope="{ item }" :value="item.stockKey.reserveMemo1" :enabled="false" />
        <TextBox :slot="adSlots[8]" slot-scope="{ item }" :value="item.stockKey.reserveMemo2" :enabled="false" />
        <TextBox :slot="adSlots[9]" slot-scope="{ item }" :value="item.stockKey.reserveMemo3" :enabled="false" />
        <TextBox :slot="adSlots[10]" slot-scope="{ item }" :value="item.stockKey.reserveDate1 | date" :enabled="false" />
        <TextBox :slot="adSlots[11]" slot-scope="{ item }" :value="item.stockKey.reserveDate2 | date" :enabled="false" />
        <TextBox :slot="adSlots[12]" slot-scope="{ item }" :value="item.stockKey.reserveDate3 | date" :enabled="false" />
        <TextBox :slot="adSlots[13]" slot-scope="{ item }" :value="item.stockKey.reserveList1 | category_41" :enabled="false" />
        <TextBox :slot="adSlots[14]" slot-scope="{ item }" :value="item.stockKey.reserveList2 | category_42" :enabled="false" />
        <TextBox :slot="adSlots[15]" slot-scope="{ item }" :value="item.stockKey.reserveList3 | category_43" :enabled="false" />
        <NumericBox :slot="adSlots[16]" slot-scope="{ item }" :value="item.availableAllocationQuantity" :enabled="false" :nullValue="0" :decimals="adOrderItem.commodity == null ? 0 : adOrderItem.commodity.quantityScale" />
        <NumericBox :slot="adSlots[17]" slot-scope="{ item }" :value ="item.stockPrice" :enabled="false"  :decimals="adOrderItem.commodity == null ? 0 : adOrderItem.commodity.stockPriceScale"/>
        <NumericBox :slot="adSlots[18]" slot-scope="{ item, editor }" :value.sync=" item.allocationQuantity" :editor="editor" :min="0" :max="adOrderItem.commodity != null && adOrderItem.commodity.isNoStock ? 99999999.999 : item.availableAllocationQuantity" :decimals="adOrderItem.commodity == null ? 0 : adOrderItem.commodity.quantityScale" />
        <Calendar :slot="adSlots[19]" slot-scope="{ item, editor }" :value.sync=" item.scheduledDeliveryDate" :editor="editor" :required="true" />
      </ListDialog>
      <!-- 引当処理ダイアログ（棚卸対象外） -->
      <ListDialog ref="allocateDialogNoStock" title="出荷引当(個別)" :captions="[]" :widths="[]" :showAdd="false" :showRemove="false" :exec="submitAllocateNoStock" >
        <template slot="header" slot-scope="{ editor }">
          <EditPanel>
            <template slot="left">
              <AtcSegment title="部門" :value="(adOrderItem.order ? adOrderItem.order.segment : null)" :enabled="false" tooltip="【受注明細一覧】で選択した【部門】が表示されます。"/>
              <AtcCommodity title="商品" :value="adOrderItem.commodity"  :enabled="false"  tooltip="【受注明細一覧】で選択した【商品】が表示されます。"/>
              <AtcSKU title="SKU" :value.sync="adOrderItem.sku" :commodity="adOrderItem.commodity" :enabled="false"  tooltip="【受注明細一覧】で選択した【SKU】が表示されます。"/>              
              <TextBox title="棚卸対象外" :value="(adOrderItem.commodity != null ? adOrderItem.commodity.isNoStock : false) | isNoStock" :enabled="false" tooltip="【受注明細一覧】で選択した【棚卸対象外】の項目が表示されます。"/>
              <AtcConversion title="単位" :value="adOrderItem.uom2" :required="true" :commodity="adOrderItem.commodity" :nullValue="''" :enabled="false" tooltip="【受注明細一覧】で選択した【単位】が表示されます。"/>
              <NumericBox title="受注残数量" :value.sync="adBackSalesOrderQuantity" :enabled="false" :nullValue="0" :decimals="adOrderItem.commodity == null ? 0 : adOrderItem.commodity.quantityScale" tooltip="【受注明細一覧】で表示されている【受注残数量】が表示されます。"/>
              <NumericBox title="出荷数量" :editor="editor" :value.sync="adAllocationQuantity" :required="true" :nullValue="0" :min="0" :max="99999999.999" />
              <Calendar title="出荷日" :editor="editor" :value.sync="adScheduledDeliveryDate" :required="true" />
            </template>
            <template slot="right">
              <!-- 商品識別情報のみ表示 -->
              <PnlReserveItems :item="adOrderItem" :tab="false" :enabled="false" :commodityAttribute="visibleTypes.Editable" :commodity="adOrderItem.commodity" />              
              </template>            
          </EditPanel>
        </template>
      </ListDialog>
      <!-- 一括引当処理画面 -->
      <b-modal v-model="visibleBulkAllocateDialog" title="出荷引当" @ok="submitBulkAllocate" :no-close-on-backdrop="true" centered>
        <AtcCounterpart title="倉庫" :value.sync="baWarehouse" :needsWarehouse="true" tooltip="商品を引当する倉庫を選択します。【取引先一覧】の【取引先種別】が【倉庫】になっているデータが選択できます。" />
        <ComboBox title="受注明細読込順" :value.sync="baOrderByOrderItem" list="allocationOrder" :showDefault="false" tooltip="複数の受注明細の中で､どの明細から引当をするかの順番を設定します。"/>
        <ComboBox title="　" :value.sync="baAdOrderItem" list="adOrder" :showDefault="false" />
        <ComboBox title="在庫明細読込順" :value.sync="baOrderByStock" :provider="()=>getStockOrder()" :showDefault="false" v-if="getStockOrder().length > 0"/>
        <ComboBox title="　" :value.sync="baAdStock" list="adOrder" :showDefault="false" v-if="getStockOrder().length > 0"/>
      </b-modal>
    </template>
  </ListView>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class SalesOrderItemView extends Vue {
  public createPurchaseOrder = Components.CreatePurchaseOrder;
  public items: Common.SalesOrderItem[] = new Array(0);
  public params: Common.OrderItemQuery = new Common.OrderItemQuery(Common.SalesPurchaseFlags.Sales);
  public importQuery = new Common.OrderItemImportQuery('受注明細',Common.SalesPurchaseFlags.Sales);
  public exportQuery = new Common.OrderItemExportQuery('受注明細', this.params,Common.SalesPurchaseFlags.Sales);
  public usedTypes = Common.UsedTypes;  
  public sortOptions: any = [
    { value: 'State', text: '状態' },
    { value: 'orderItemNo', text: '明細番号' },
    { value: 'orderDate', text: '受注日' },
    { value: 'counterpart', text: '得意先' },
    { value: 'commodity', text: '商品' },
    { value: 'sku', text: 'SKU' },
    { value: 'uom', text: '単位' },
    { value: 'quantity', text: '受注数量' },
    { value: 'answerDeliveryDate', text: '回答納期' },
    { value: 'scheduledDeliveryDate', text: '出荷予定日' },
    { value: 'orderNo', text: '受注番号' },
    { value: 'supplier', text: '発注先' },
    { value: 'segment', text: '部門' },
    { value: 'pic', text: '担当者' },
    { value: 'commodityName', text: '商品名称' },
    { value: 'refNo', text: '受注管理番号' },
    { value: 'customerOrderNo', text: '顧客注文番号' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },
  ];
  public tabVisibles: Array<boolean> = [true, true, true, true, true, true, true];
  public tenantSettings: Common.TenantSettings = null;
  public voucherTypes = Common.voucherTypes;
  public visibleTypes = Common.visibleTypes;
  public updateDeliveryDate = Components.UpdateDeliveryDate;

  public dispFlag: number = Common.InputTypes.SalesDelivery;
  @Prop() public orderNo:string;
  @Prop() public orderItemNo:string;
  @Prop() public commodity:Common.Commodity;
  @Prop() public sku:Common.SKU;  
  @Prop() public state:Common.OrderItemStatus;    
  @Prop() public scheduledDeliveryDateTo: Date;
  @Prop({default:null}) public popup: Components.PopupEditor;  
  
  public hasLicenseCurrency: boolean = false;
  // 一覧可変表示用プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public listVisbles = new Array();  
  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'grid');
  
  public created() {
    //テナント設定をロードする
    // this.$api.execute(new Common.TenantSettingsLoadQuery()).then(res => (this.tenantSettings = res));
    this.tenantSettings = this.$api.tenantSettings;

    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);

    // タブ表示の制御
    this.$set(this.tabVisibles, 5, this.$api.useStockFunction); // 予備項目タブ

    // :gridCaptions="['状態', '明細ID', '受注番号', '行番号', '明細番号', '受注日', '部門', '得意先', '担当者', '商品', '商品名称', '棚卸対象外', '単位', 'SKU', '受注数量','取引通貨', '単価', '税区分', 'NCV', '取引金額', '備考', '発注先',
    // '回答納期', '出荷予定日', '受注残数量', '受注残数量(計上単位)', '引当待ち数量', '発注残数量', '引当済数量', 'クローズ数量', '管理番号', '顧客注文番号', 'ワークフロー', '初回保存日', '初回保存者', '最終更新日', '最終更新者']"
    // :gridWidths="[170, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150,  150, 150, 150, 150, 150, 150,150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150]"

    // 一覧表示項目の制御
    this.gridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 150),
      new Common.GridItemConfiguration('明細番号', 140),
      new Common.GridItemConfiguration('受注日', 100),
      new Common.GridItemConfiguration('得意先', 180),
      new Common.GridItemConfiguration('商品', 180),
      new Common.GridItemConfiguration('SKU', 150),   
      new Common.GridItemConfiguration('単位', 100),           
      new Common.GridItemConfiguration('受注数量', 120),      
      new Common.GridItemConfiguration('回答納期', 120),
      new Common.GridItemConfiguration('出荷予定日', 120),   
      new Common.GridItemConfiguration('取引通貨', 120,this.hasLicenseCurrency),
      new Common.GridItemConfiguration('単価', 120),
      new Common.GridItemConfiguration('税区分', 120),
      new Common.GridItemConfiguration('上代単価', 120),
      new Common.GridItemConfiguration('仕入単価', 120),
      new Common.GridItemConfiguration('粗利', 120),
      new Common.GridItemConfiguration('発注先', 150),
      new Common.GridItemConfiguration('案件', 150),      
      new Common.GridItemConfiguration('部門', 150),
      new Common.GridItemConfiguration('担当者', 150),            
      new Common.GridItemConfiguration('受注番号', 150),            
      // new Common.GridItemConfiguration('明細ID', 150),
      // new Common.GridItemConfiguration('行番号', 150),
      // new Common.GridItemConfiguration('備考', 150),           
      new Common.GridItemConfiguration('商品名称', 150),
      new Common.GridItemConfiguration('NCV', 150,this.hasLicenseCurrency),         
      new Common.GridItemConfiguration('棚卸対象外', 150),
      new Common.GridItemConfiguration('取引金額', 150),
      new Common.GridItemConfiguration('引当済数量', 150),
      new Common.GridItemConfiguration('クローズ数量', 150),           
      new Common.GridItemConfiguration('受注残数量', 150),
      new Common.GridItemConfiguration('引当待ち数量', 150),      
      new Common.GridItemConfiguration('入荷待ち数量', 150),
      new Common.GridItemConfiguration('受注残数量(計上単位)', 150),                
      new Common.GridItemConfiguration('受注管理番号', 150),              
      new Common.GridItemConfiguration('顧客注文番号', 150),
      // new Common.GridItemConfiguration('ワークフロー', 150),
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 150),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 150),          
    );
    //予備項目追加〜非表示
    this.gridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,false,true,true,false));

    this.listCaptions = this.gridConfig.gridCaptions;
    this.listWidths = this.gridConfig.gridWidths;
    this.listSlots = this.gridConfig.gridSlots;
    this.listVisbles = this.gridConfig.gridVisibles;
    this.exportQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    // 検索条件を設定する
    if(this.orderNo) {
      this.params.orderNo = this.orderNo;
      this.params.state = null;
    }
    else if(this.orderItemNo) {
      this.params.orderItemNo = this.orderItemNo;
      this.params.state = null;
    }else if (!this.commodity && !this.sku && !this.state && !this.scheduledDeliveryDateTo){
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) this.params.state = null;
        
        
    if (this.commodity)this.params.commodity = this.commodity;
    if (this.sku)this.params.sku = this.sku;
    if (this.state)this.params.state = this.state;       
    if (this.scheduledDeliveryDateTo)this.params.scheduledDeliveryDateTo = this.scheduledDeliveryDateTo;        
    
    // 子画面用ワークフロー情報をロードする
    this.$api.formatter.ensureListLoaded('workflow_purchaseOrder');
    this.$api.formatter.ensureListLoaded('workflow_salesDelivery');
  }

  // public beforeRouteUpdate(to:any, from:any, next :Function){
  //   Common.QueryParamUtility.loadQueryParams(to,from,next);
  // }
  // public beforeRouteEnter (to:any, from:any, next :Function) {
  //   Common.QueryParamUtility.loadQueryParams(to,from,next);
  // }

  public async onCreate(obj: Common.SalesOrderItem) {
    // const workflows = this.$api.formatter.getOptions('workflow_salesOrderItem');
    // if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  // 画面のリフレッシュ(再描画)
  public refreshListView(){
    var page = (this.$refs.mainList as Components.ListView).currentPage;
    (this.$refs.mainList as Components.ListView).onPageChange(page);
  }

  // 商品変更時に商品名・予備項目を設定する
  public onChangeCommodity(item:Common.OrderItem){
    item.onChangeCommodity(this.tenantSettings);
  }

  // 単価・税区分を取得する
  public getPriceAndTaxCode(item:Common.SalesOrderItem){
    this.$api.execute(new Common.OrderGetItemPriceQuery(item.order, item)).then(res => {
      item.unitPrice = res.unitPrice;
      item.taxCode = res.taxCode;
    });
  }

  // 受注数量の最小値を取得する
  public getMinQuantity(item:Common.SalesOrderItem){
    let minQuantity = item.allocatedQuantity + item.purchasePendingQuantity + item.closedQuantity;
    if(minQuantity != 0) return minQuantity;
    if(item.commodity && item.commodity.isNoStock) return -99999999.999;
    else return 0;
  }

  // 状態から編集可能か判別する
  public isEditable(state: Common.OrderItemStatus):boolean{
    if(state == Common.OrderItemStatus.SalesOrderSaving) return true;
    if(state == Common.OrderItemStatus.SalesOrderWaiting) return true;
    return false;
  }
  // 状態が失注か判別する
  public isStateLost(state: Common.OrderItemStatus):boolean{
    return state == Common.OrderItemStatus.SalesOrderLost;
  }
  public isComplete(state: Common.OrderItemStatus):boolean{
    if(state == Common.OrderItemStatus.SalesOrderCompleted) return true;
    return false;
  }

  // 一覧でチェックされている受注明細
  public checkedOrderItems: Array<Common.SalesOrderItem>= new Array(0);
  public getCheckedOrderItems(){
    this.checkedOrderItems = new Array(0);
    const view = this.$refs.mainList as Components.ListView;
    this.items.forEach((obj, index) => {
      if ((view.$refs.listBox as Components.Grid).checked[index]) {
        this.checkedOrderItems.push(obj);
      }
    });
  }

  // 納期更新用プロパティ
  // public uddAnswerDeliveryDate:Date = null;
  // public uddScheduledDeliveryDate:Date = null;

  // // 納期更新ダイアログの表示
  public showUpdateDeliveryDateDialog() {
    this.getCheckedOrderItems();
    
    let componentClass = Vue.extend(this.updateDeliveryDate);
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          checkedOrderItems: this.checkedOrderItems,
          parentMainList:this.$refs.mainList,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);


  //   // ダイアログ表示前バリデーション
  //   if(this.checkedOrderItems.length == 0){
  //     this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);
  //     return;
  //   }
  //   if(this.checkedOrderItems.filter(item => item.order.isSubscription).length > 0){
  //     this.$api.modal.show('', 'サブスクリプション明細の納期更新は行えません。', true, null);
  //     return;
  //   }    
  //   // プロパティの初期化
  //   this.uddAnswerDeliveryDate = null;
  //   this.uddScheduledDeliveryDate = null;

  //   // ダイアログを表示
  //   (this.$refs.updateDeliveryDateDialog as Components.ListDialog).showDialog();
  }

  // // 納期更新の実行
  // public async submitUpdateDeliveryDate() {
  //   // クエリの設定
  //   var query = new Common.UpdateDeliveryDateQuery();
  //   query.orderItems = this.checkedOrderItems;
  //   query.answerDeliveryDate = this.uddAnswerDeliveryDate;
  //   query.scheduledDeliveryDate = this.uddScheduledDeliveryDate;

  //   // 納期更新の実行
  //   await this.$api.execute(query).then(res => {
  //     this.refreshListView();
  //   });
  // }

  public uddSubscriptionEndDate:Date = null;
  // 契約日更新
  public showUpdateSubscriptionEndDate(){
    this.getCheckedOrderItems();

    // ダイアログ表示前バリデーション
    if(this.checkedOrderItems.length == 0){
      this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);
      return;
    }
    if(this.checkedOrderItems.filter(item => item.order.isSubscription).length <= 0){
      this.$api.modal.show('', 'サブスクリプション明細を選択して下さい。', true, null);
      return;
    }    
    // プロパティの初期化
    this.uddSubscriptionEndDate = null;

    // ダイアログを表示
    (this.$refs.updateSubscriptionEndDateDialog as Components.ListDialog).showDialog();
  }
  // 契約日更新の実行
  public async submitSubscriptionEndDate() {
    // クエリの設定
    var query = new Common.UpdateSubscriptionEndDateQuery();
    query.orderItems = this.checkedOrderItems.filter(item => item.order.isSubscription);
    query.subscriptionEndDate = this.uddSubscriptionEndDate;

    // 契約日更新の実行
    await this.$api.execute(query).then(res => {
      this.refreshListView();
    });
  }

  // 引当処理用プロパティ
  public adInputType:Common.InputTypes = Common.InputTypes.SalesOrder;
  public adCaptions = new Array();
  public adWidths = new Array();
  public adSlots = new Array();
  public adGridConfig:Common.GridConfiguration =
    new Common.GridConfiguration([
      new Common.GridItemConfiguration('倉庫', 200),
      new Common.GridItemConfiguration('予定在庫数量', 200),
      new Common.GridItemConfiguration('在庫単価', 200),
      new Common.GridItemConfiguration('出荷数量', 200),
      new Common.GridItemConfiguration('出荷日', 200),
    ],
    1, // 倉庫の次を予備項目の挿入位置に指定
    'col'
  );
  public adOrderItem: Common.SalesOrderItem = new Common.SalesOrderItem();
  public adBackSalesOrderQuantity = 0;
  public adAllocationQuantity = 0;
  public adScheduledDeliveryDate = new Date();
  public adListStockBalanceNoStock = new Array();

  // 引当処理用バリデーション
  public validateForAllocation(orderItem: Common.SalesOrderItem):string{
    if (orderItem == null){
      return '引当可能な明細を選択して下さい。';
    }
    //ステータス変更にともないコメント
    // if(orderItem.isNoStock == false){
    //   if (orderItem.state != Common.OrderItemStatus.SalesOrderUnallocated && orderItem.state != Common.OrderItemStatus.SalesOrderAllocating && orderItem.state != Common.OrderItemStatus.SalesOrderAllocatingArrivalWaiting){
    //     return '引当可能な明細を選択して下さい。';
    //   }
    // }else{
    //   if (orderItem.state != Common.OrderItemStatus.SalesOrderUndelivered && orderItem.state != Common.OrderItemStatus.SalesOrderDelivering){
    //     return '引当可能な明細を選択して下さい。';
    //   }
    // }
    //ステータス変更にともない条件変更
    if (orderItem.state  < Common.OrderItemStatus.SalesOrderUnallocated){
      return '受注一覧で受注確定がされた明細を選択して下さい。';
    }
    if(orderItem.backSalesOrderQuantity == 0){
      return '受注残数量のある明細を選択し、引当処理をしてください。';
    }
    if(orderItem.scheduledDeliveryDate == null){
      return '出荷予定日を入力して下さい。';
    }
    return '';
  }

  // 引当処理ダイアログの表示
  public showAllocateDialog() {
   this.getCheckedOrderItems();

    if(this.checkedOrderItems.length > 1){
      this.$api.modal.show('', '単一の明細を選択して下さい。', true, null);
      return;
    }
    if(this.checkedOrderItems.filter(item => item.order.isSubscription).length > 0){
      this.$api.modal.show('', 'サブスクリプション明細の出荷引当は行えません。', true, null);
      return;
    } 

    const temp =  this.checkedOrderItems[0] as Common.SalesOrderItem;
    this.adOrderItem = temp as Common.SalesOrderItem;
  
    // ダイアログ表示前バリデーション
    var message: string = this.validateForAllocation(this.adOrderItem);
    if(message.length > 0){
      this.$api.modal.show('', message, true, null);
      return;
    }

    // 明細の予備項目表示の可変対応
    var reserveItems = this.tenantSettings.GetGridItems(false,true,false,false,false);//在庫識別情報
    this.adGridConfig.setVariableItems(reserveItems);
    this.adCaptions =this.adGridConfig.gridCaptions;
    this.adWidths = this.adGridConfig.gridWidths;
    this.adSlots = this.adGridConfig.gridSlots;
    this.adBackSalesOrderQuantity = temp.backSalesOrderQuantity;
    
    // クエリの設定
    var query = new Common.StockBalanceAllocateQuery();
    query.orderItem = temp as Common.OrderItem;

    if(this.adOrderItem.commodity != null && this.adOrderItem.commodity.isNoStock)
    {
      // 在庫情報をロードする（棚卸対象外のダミー1行分のみ）
      // サーバー側でインスタンスを作成しないとサーバー側でのデシリアライズに失敗してしまう
      this.$api.execute(query).then(res => {
        this.adListStockBalanceNoStock = (res as Common.LoadResult).result;
        this.adAllocationQuantity = 0;
        this.adScheduledDeliveryDate = this.adOrderItem.scheduledDeliveryDate;
        (this.$refs.allocateDialogNoStock as Components.ListDialog).showDialog();
      });
    }
    else
    {
      // 在庫情報をロードする
      this.$api.execute(query).then(res => {
        var items: Array<Common.OrderItem> = (res as Common.LoadResult).result;
        items.forEach(obj => obj.scheduledDeliveryDate = this.adOrderItem.scheduledDeliveryDate);
        (this.$refs.allocateDialog as Components.ListDialog).items = items;
        (this.$refs.allocateDialog as Components.ListDialog).showDialog();
      });
    }
  }

  // 引当処理の実行
  public async submitAllocate(list: Array<Common.StockBalance>)
  {
    // メッセージを表示後に子画面が閉じてしまうため、仮実装
    // 引当処理前のバリデーション
    if(list.filter(obj => obj.allocationQuantity == 0).length == list.length){
      this.$api.modal.show('', 'ゼロを指定することはできません。', true, ()=>{
        this.showAllocateDialog();
      });
      return;
    }
    if(list.map(obj => obj.allocationQuantity).reduce((total, value)=>total += value) > this.adOrderItem.backSalesOrderQuantity){
      this.$api.modal.show('', '受注残数量以下の数値を指定して下さい。', true, ()=>{
        this.showAllocateDialog();
      });
      return;
    }

    // クエリの設定
    var query = new Common.AllocateQuery();
    query.orderItem = (this.$refs.mainList as Components.ListView).selected as Common.OrderItem;
    query.stockBalances = list;

    // 引当処理の実行
    return this.$api.execute(query,true).then(res => {
      //リスト更新
      (this.$refs.mainList as Components.ListView).onSubmit(res);
      //出荷明細タブのリロード
      (this.$refs.salesDeliveryItems as Components.GrdVoucherItem).onVoucherNoChanged();
      this.$api.modal.show('処理結果','処理が完了しました。',true,null);
      return true;
    }).catch(()=>{return false;});      

    // await this.$api.execute(query).then(res => {
    //   this.refreshListView();      
    //   (this.$refs.salesDeliveryItems as Components.GrdVoucherItem).onVoucherNoChanged();//リロードする
    // });
      
  }
  public async submitAllocateNoStock()
  {
    // メッセージを表示後に子画面が閉じてしまうため、仮実装
    // 引当処理前のバリデーション
    if(this.adAllocationQuantity == 0){
      this.$api.modal.show('', 'ゼロを指定することはできません。', true, ()=>{
        this.showAllocateDialog();
      });
      return;
    }
    if(this.adAllocationQuantity > this.adOrderItem.backSalesOrderQuantity){
      this.$api.modal.show('', '受注残数量以下の数値を指定して下さい。', true, ()=>{
        this.showAllocateDialog();
      });
      return;
    }
    this.adListStockBalanceNoStock[0].allocationQuantity = this.adAllocationQuantity;
    this.adListStockBalanceNoStock[0].scheduledDeliveryDate = this.adScheduledDeliveryDate;
    
    // クエリの設定
    var query = new Common.AllocateQuery();
    query.orderItem = (this.$refs.mainList as Components.ListView).selected as Common.OrderItem;
    query.stockBalances = this.adListStockBalanceNoStock;

    // 引当処理の実行
    return this.$api.execute(query).then(res => {
      //リスト更新
      (this.$refs.mainList as Components.ListView).onSubmit(res);
      //出荷明細タブのリロード
      (this.$refs.salesDeliveryItems as Components.GrdVoucherItem).onVoucherNoChanged();
      this.$api.modal.show('処理結果','処理が完了しました。',true,null);
      return true;
    }).catch(()=>{return false;});  
  }

  // 一括引当処理用プロパティ
  public visibleBulkAllocateDialog:boolean = false;
  public baSegment: Common.Segment = null;
  public baWarehouse: Common.Counterpart = null;
  public baOrderByOrderItem: Common.AllocationOrder = Common.AllocationOrder.OrderDate;
  public baAdOrderItem: boolean = true;
  public baOrderByStock: Common.StockOrder = Common.StockOrder.SKU;
  public baAdStock: boolean = true;

  // 一括引当処理ダイアログの表示
  public showBulkAllocateDialog(){
    this.getCheckedOrderItems();

    // ダイアログ表示前バリデーション
    if(this.checkedOrderItems.length == 0){
      this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);
      return;
    }
    this.baSegment = this.checkedOrderItems[0].order.segment;
    if(this.checkedOrderItems.filter(item => item.order.segmentId != this.baSegment.id).length > 0){
      this.$api.modal.show('', '複数部門に対する一括引当処理はできません。', true, null);
      return;
    }
    if(this.baSegment.priceCalculationMethod == Common.PricingTypes.Specific){
      this.$api.modal.show('', '在庫単価計算が個別法の部門は、一括引当処理の対象外です。', true, null);
      return;
    }
    if(this.checkedOrderItems.filter(item => item.order.isSubscription).length > 0){
      this.$api.modal.show('', 'サブスクリプション明細の出荷引当は行えません。', true, null);
      return;
    }    
    for(var item of this.checkedOrderItems){
      var message: string = this.validateForAllocation(item);
      if(message.length > 0){
        this.$api.modal.show('', message, true, null);
        return;
      }
    }

    // プロパティの初期化
    this.baWarehouse = null;
    this.baOrderByOrderItem = Common.AllocationOrder.OrderDate;
    this.baAdOrderItem =  true;
    this.baOrderByStock = Common.StockOrder.SKU;
    this.baAdStock =  true;

    // 一括引当処理ダイアログの表示
    if(this.checkedOrderItems.filter(obj => obj.commodity.isNoStock == false).length > 0)
    {
      this.visibleBulkAllocateDialog = true;
    }
    else
    {
      this.$api.modal.showDialog('確認メッセージ','出荷引当を実行してよろしいですか？',false).then(()=>{
        this.submitBulkAllocate();
      });
    }
  }

  // 
  public getStockOrder():Common.BindItem[]{
    // 在庫読込順からSKUを除外
    // var list = [new Common.BindItem(Common.StockOrder.SKU, 'SKU'),];
    var list = []; 
    if(this.tenantSettings.usedTypeDetailReserveText1 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText1, this.tenantSettings.nameReserveText1));
    if(this.tenantSettings.usedTypeDetailReserveText2 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText2, this.tenantSettings.nameReserveText2));
    if(this.tenantSettings.usedTypeDetailReserveText3 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText3, this.tenantSettings.nameReserveText3));
    if(this.tenantSettings.usedTypeDetailReserveText4 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText4, this.tenantSettings.nameReserveText4));
    if(this.tenantSettings.usedTypeDetailReserveText5 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText5, this.tenantSettings.nameReserveText5));
    if(this.tenantSettings.usedTypeDetailReserveText6 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText6, this.tenantSettings.nameReserveText6));
    if(this.tenantSettings.usedTypeDetailReserveMemo1 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveMemo1, this.tenantSettings.nameReserveMemo1));
    if(this.tenantSettings.usedTypeDetailReserveMemo2 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveMemo2, this.tenantSettings.nameReserveMemo2));
    if(this.tenantSettings.usedTypeDetailReserveMemo3 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveMemo3, this.tenantSettings.nameReserveMemo3));
    if(this.tenantSettings.usedTypeDetailReserveList1 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveList1, this.tenantSettings.nameReserveList1));
    if(this.tenantSettings.usedTypeDetailReserveList2 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveList2, this.tenantSettings.nameReserveList2));
    if(this.tenantSettings.usedTypeDetailReserveList3 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveList1, this.tenantSettings.nameReserveList3));
    if(this.tenantSettings.usedTypeDetailReserveDate1 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveDate1, this.tenantSettings.nameReserveDate1));
    if(this.tenantSettings.usedTypeDetailReserveDate2 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveDate2, this.tenantSettings.nameReserveDate2));
    if(this.tenantSettings.usedTypeDetailReserveDate3 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveDate3, this.tenantSettings.nameReserveDate3));
    // if(this.baSegment && this.baSegment.reserveText1StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText1, '予備テキスト1'));
    // if(this.baSegment && this.baSegment.reserveText1StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText1, '予備テキスト1'));
    // if(this.baSegment && this.baSegment.reserveText1StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText1, '予備テキスト1'));
    // if(this.baSegment && this.baSegment.reserveText1StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText1, '予備テキスト1'));
    // if(this.baSegment && this.baSegment.reserveText2StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText2, '予備テキスト2'));
    // if(this.baSegment && this.baSegment.reserveText3StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText3, '予備テキスト3'));
    // if(this.baSegment && this.baSegment.reserveText4StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText4, '予備テキスト4'));
    // if(this.baSegment && this.baSegment.reserveText5StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText5, '予備テキスト5'));
    // if(this.baSegment && this.baSegment.reserveText6StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText6, '予備テキスト6'));
    // if(this.baSegment && this.baSegment.reserveMemo1StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveMemo1, '予備メモ1'));
    // if(this.baSegment && this.baSegment.reserveMemo2StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveMemo2, '予備メモ2'));
    // if(this.baSegment && this.baSegment.reserveMemo3StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveMemo3, '予備メモ3'));
    // if(this.baSegment && this.baSegment.reserveList1StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveList1, '予備リスト1'));
    // if(this.baSegment && this.baSegment.reserveList2StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveList2, '予備リスト2'));
    // if(this.baSegment && this.baSegment.reserveList3StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveList3, '予備リスト3'));
    // if(this.baSegment && this.baSegment.reserveDate1StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveDate1, '予備日付1'));
    // if(this.baSegment && this.baSegment.reserveDate2StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveDate2, '予備日付2'));
    // if(this.baSegment && this.baSegment.reserveDate3StockAttribute == Common.StockTypes.Balance) list.push(new Common.BindItem(Common.StockOrder.DetailReserveDate3, '予備日付3'));
    return list;
  }

  // 一括引当処理の実行
  public async submitBulkAllocate(){
    this.getCheckedOrderItems();

    // クエリの設定
    var query = new Common.BulkAllocateQuery(this.checkedOrderItems);
    query.warehouse = this.baWarehouse;
    query.orderByOrderItem = this.baOrderByOrderItem;
    query.adOrderItem = this.baAdOrderItem;
    query.orderByStock = this.baOrderByStock;
    query.adStock = this.baAdStock;

    // 一括引当処理の実行
    await this.$api.execute(query,true).then(res => {
      this.refreshListView();
      //リロードする
      (this.$refs.salesDeliveryItems as Components.GrdVoucherItem).onVoucherNoChanged();
      this.$api.modal.show('処理結果',res.cntSelect + '件中' + res.cntSuccess + '件の出荷引当が完了しました。',true,null);
      return true;
    }).catch(()=>{return false;}); 

  }

  // 発注処理ダイアログの表示
  public showCreatePurchaseOrderDialog() {
    this.getCheckedOrderItems();

    if(this.checkedOrderItems.filter(item => item.order.isSubscription).length > 0){
      this.$api.modal.show('', 'サブスクリプション明細の発注処理は行えません。', true, null);
      return;
    }    

    let componentClass = Vue.extend(this.createPurchaseOrder);
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          checkedOrderItems: this.checkedOrderItems,
          parentMainList: this.$refs.mainList,
          parent: this,
          isItemFlag: true,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);
  }

  // 伝票表示(受注一覧へ遷移)
  public showSalesOrder() {
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.SalesOrderItem;
    this.$router.push(String.format('/sales/SalesOrder?orderNo={0}',obj.order.orderNo));
  }

  // 一覧選択時に明細表示ボタンを非活化状態を更新
  public onSelectedMain(index: number, selected: Common.Order) {
    // 発注明細表示ボタンの非活化状態を更新
    this.disabledShowPurchaseOrderItemButton = selected.state <= Common.OrderItemStatus.SalesOrderAllocating
    || selected.state == Common.OrderItemStatus.SalesOrderUndelivered;

    // 出荷明細表示ボタンの非活化状態を更新
    this.disabledShowSalesDeliveryItemButton
      = selected.state <= Common.OrderItemStatus.SalesOrderUnallocated
      || selected.state == Common.OrderItemStatus.SalesOrderArrivalWaiting
      || selected.state == Common.OrderItemStatus.SalesOrderUndelivered;
  }
  
  // 発注明細表示表示ボタンの非活性判別
  public disabledShowPurchaseOrderItemButton: boolean = true;

  // 出荷明細表示ボタンの非活性判別
  public disabledShowSalesDeliveryItemButton: boolean = true;
  //関連伝票ダイアログを表示
  public showDirectAccessDialg(item:Common.SalesOrderItem){
    this.$api.launchDialog(Components.DirectAccessDialog, this.$router,{source : Common.DirectAccessTargetFlags.SalesOrder, sourceNo : item.orderNo, isItem: true},this.$el);
  }
  // 発注明細一覧を表示
  public showPurchaseOrderItems() {
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.SalesOrderItem;
    let routeData = this.$router.resolve(String.format('/purchase/PurchaseOrderItem?salesOrderItemNo={0}',obj.orderItemNo));
    window.open(routeData.href, '_blank');
  }

  // 出荷明細一覧を表示
  public showSalesDeliveryItems() {
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.SalesOrderItem;
    let routeData = this.$router.resolve(String.format('/sales/SalesDeliveryItem?orderItemNo={0}',obj.orderItemNo));
    window.open(routeData.href, '_blank');
  }

  //検索予備項目
  public isSearchVisible(usedType: Common.UsedTypes){
      return usedType == Common.UsedTypes.CommodityAttribute || usedType == Common.UsedTypes.OrderMemo || usedType == Common.UsedTypes.CommodityMemo ;
  }  
  public get searchTabs() : string[]{
    return this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText1) || 
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText2) || 
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText3) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText4) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText5) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText6) ||                
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveMemo1) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveMemo2) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveMemo3) ||                         
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveDate1) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveDate2) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveDate3) ||            
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveList1) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveList2) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveList3) 
              ? ['検索条件','予備項目']: ['検索条件'];
  }
}
</script>

<style lang="scss">
.cx_itembutton {
  font-size: 14px;
  height: 28px;
  padding: 2px 7px;
  outline: 0 !important;
  box-shadow: none;
  margin: -3px 10px 10px 0px;
  // min-width:120px;
}
</style>